export default {
  title: 'Esta é uma SAFE Tag!',
  subtitle: {
    isNotSosafeUser:
      'Baixe nosso aplicativo para escanear seu SAFE Tag e comece a ser protegido pelo SOSAFE',
  },
  downloadApp: 'Baixar SOSAFE',
};
